import { RefAttributes, forwardRef } from 'react';
import { IconButton, IconButtonProps, Badge, SxProps } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

type FilterButtonProps = IconButtonProps &
  RefAttributes<HTMLButtonElement> & {
    showBadge?: boolean;
    badgeSx?: SxProps;
  };

export const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ showBadge, badgeSx, ...props }, ref) => {
    return (
      <Badge
        color='error'
        variant='dot'
        invisible={!showBadge}
        overlap='circular'
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiBadge-dot': (theme) => ({ top: theme.spacing(1.5), right: theme.spacing(1) }),
          ...badgeSx,
        }}
      >
        <IconButton {...props} sx={props.sx} ref={ref}>
          <FilterListIcon fontSize='inherit' />
        </IconButton>
      </Badge>
    );
  },
);

//TODO Wherever values 'any, Any, All, ALL, ...' are used to clear the filter, use null if possible
export const isFiltersSelected = (filterValues: unknown[], ignoreValues: string[] = []) => {
  let applied = false;
  filterValues.forEach((item) => {
    const ignoreItem = !!ignoreValues.find((ignoreItem) => ignoreItem === item);
    if (ignoreItem) return;
    if (item) applied = true;
  });
  return applied;
};
